import { useEffect, useState } from "react";
import useDebounce from "./../../customHook/useDebounce";
import IconButton from "./IconButton";

import Icon from "../../assets/icons/Icon";

const Searchbar = ({
  value,
  onChange,
  isFilterActive,
  handleFilterClick,
  handleRefreshClick,
  placeholder = "Search...",
  hideFilter,
  hideRefresh
}) => {
  const [inputValue, setInputValue] = useState(value || "");
  const debouncedValue = useDebounce(inputValue, 500); // 500ms debounce delay

  const handleInputChange = (e) => {
    const newValue = e.target.value;
    setInputValue(newValue);
  };

  // Clear input on clear icon click
    useEffect(() => {
    setInputValue(value || "");
  }, [value]);

  // Update parent on debounce change
  useEffect(() => {
    onChange(debouncedValue);
  }, [debouncedValue]);

  return (
    <div className="flex h-[34px] justify-between items-center w-full bg-white border border-[#d7d5e2] rounded-lg hover:border-[#408dfb] focus-within:shadow-[0_0_0_3px_rgba(64,_141,_251,_0.16)]">
   <span className=" w-7 inline-block pl-3 text-gray-500 ">


        <Icon type="search"></Icon>
      </span>

      
      <input
        type="text"
        value={inputValue}
        onChange={handleInputChange}
        className="inline-block w-full px-2 h-[34px]  outline-none "
        placeholder={placeholder}
      />

      <span className="flex items-center gap-2">
        {inputValue && (
          <span
            className="inline-block w-10 text-gray-400 px-2  hover:text-gray-500 pr-2"
            onClick={() => setInputValue("")}
          >
            <Icon type="remove" />
          </span>
        )}
      </span>

      {!hideRefresh &&
      <span
      onClick={handleRefreshClick || (() => {})}
      className="w-11 text-gray-500 hover:text-gray-600 px-2 border-l border-[#d7d5e2] cursor-pointer h-[32px] flex items-center justify-center"
    >
      <Icon type="refresh" />
    </span>
    
      }

      {!hideFilter &&
      <span
      onClick={handleFilterClick || (() => {})}
      className="relative w-10 px-2 border-l border-[#d7d5e2] cursor-pointer h-[32px] flex items-center justify-center"
    >
      <span className={`w-full ${isFilterActive ? "text-green-700" : "text-gray-500 hover:text-gray-600"}`}>
      <Icon 
        type="filter" 
      />
      </span>
     
      
      {/* Green indicator dot */}
      {isFilterActive && (
        <span className="absolute top-1.5 right-1.5">
          <span className="relative flex h-2 w-2">
            <span className="animate-ping absolute inline-flex h-full w-full rounded-full bg-green-400 opacity-75"></span>
            <span className="relative inline-flex rounded-full h-2 w-2 bg-green-600"></span>
          </span>
        </span>
      )}
    </span>
   
      }
    </div>
  );
};

export default Searchbar;